import axios from 'axios';
import { API_BASE_URL } from '@/config';

export class ReportTemplatesApi {
  static getReportTemplates = (params = {}) => {
    return axios.get(`${API_BASE_URL}/outbound-reporting`, { params });
  };

  static getReportTemplate = (id) => {
    return axios.get(`${API_BASE_URL}/outbound-reporting/${id}`);
  };

  static createReportTemplate = (data) => {
    return axios.post(`${API_BASE_URL}/outbound-reporting`, data);
  };

  static updateReportTemplate = (id, data) => {
    return axios.put(`${API_BASE_URL}/outbound-reporting/${id}`, data);
  };

  static disableReportTemplate = (id) => {
    return axios.patch(`${API_BASE_URL}/outbound-reporting/${id}/disable`);
  };

  static enableReportTemplate = (id) => {
    return axios.patch(`${API_BASE_URL}/outbound-reporting/${id}/enable`);
  };

  static deleteReportTemplate = (id) => {
    return axios.delete(`${API_BASE_URL}/outbound-reporting/${id}`);
  };
}
